import NTIcon from 'components/nt-icon'
import LoadingSpinner from 'components/loading-spinner'
import ScrollClose from 'components/scroll-close'
import ROField from 'components/read-only-field'
import Tooltip from 'components/tooltip'
import FileUploader from 'components/file-uploader'
import Breadcrumbs from 'components/breadcrumbs'
import CrudTable from 'components/crud-table'
import FilterDrawer from 'components/filter-drawer'
import ExpandableColumnOptions from 'components/expandable-column-options.vue'
import DonutChart from 'components/donut-chart.vue'
import DateField from 'components/date-field.vue'

export default {
  install(Vue) {
    Vue.component('nt-icon', NTIcon)
    Vue.component('loading-spinner', LoadingSpinner)
    Vue.component('scroll-close', ScrollClose)
    Vue.component('breadcrumbs', Breadcrumbs)
    Vue.component('read-only-field', ROField)
    Vue.component('tooltip', Tooltip)
    Vue.component('file-uploader', FileUploader)
    Vue.component('crud-table', CrudTable)
    Vue.component('filter-drawer', FilterDrawer)
    Vue.component('expandable-column-options', ExpandableColumnOptions)
    Vue.component('donut-chart', DonutChart)
    Vue.component('date-field', DateField)
  }
}
